import { extendTheme } from "@mui/joy";

export default extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          plainColor: "#56B93A",
          solidBg: "#56B93A",

          solidHoverBg: "#3f8b2a",
          solidActiveBg: "#2c611d",
        },
        success: {
          solidBg: "#2DA44E",
          solidHoverBg: "#2C974B",
          solidActiveBg: "#298E46",
        },
        neutral: {
          plainColor: "#fff",
          plainHoverColor: "#fff",
          plainActiveColor: "#56B93A",
          plainHoverBg: "#25252a",
          plainActiveBg: "#25252a",
          softBg: "#25252a",
        },
        focusVisible: "rgba(86, 185, 58, 0.7)",
        background: {
          surface: "#25252a",
          popup: "#25252a",
        },
        text: {
          primary: "#56B93A",
          secondary: "#56B93A",
        },
      },
    },
  },
  components: {
    JoyButton: {
      styleOverrides: {
        root: ({ _ownerState, _theme }) => ({
          padding: "8px 12px",
          border: "1px solid rgba(0, 0, 0, 1)",
          borderRadius: "0",
          backgroundColor: "rgba(0, 0, 0, 1)",
          color: "rgba(255, 255, 255, 1)",
          textTransform: "uppercase",
          fontWeight: 600,
          "&:hover": {
            backgroundColor: "#56B93A",
            color: "rgba(255, 255, 255, 1)",
            border: "1px solid #56B93A",
          },
        }),
      },
    },
    JoySelect: {
      styleOverrides: {
        root: ({ _ownerState, _theme }) => ({
          padding: "8px 12px",
          border: "1px solid rgb(112, 112, 112)",
          borderRadius: "0",
          backgroundColor: "rgb(37, 37, 42)",
          fontSize: "12px",
          minWidth: "160px",
          color: "rgb(112, 112, 112)",
          textTransform: "uppercase",
          fontWeight: 600,
          "&:hover": {
            borderColor: "#0073aa",
            boxShadow: "0 0 0 1px #0073aa",
          },
        }),
      },
    },
    JoyOption: {
      styleOverrides: {
        root: ({ _ownerState, _theme }) => ({
          padding: "8px 12px",
          borderRight: "1px solid rgb(112, 112, 112)",
          borderBottom: "none",
          borderTop: "none",
          borderLeft: "1px solid rgb(112, 112, 112)",
          boxSizing: "border-box",
          borderRadius: "0",
          fontSize: "12px",
          minWidth: "160px",
          color: "rgb(112, 112, 112)",
          textTransform: "uppercase",
          fontWeight: 600,
          "&:first-of-type": {
            borderTop: "1px solid rgb(112, 112, 112)",
          },
          "&:last-child": {
            borderBottom: "1px solid rgb(112, 112, 112)",
          },
          "&:hover": {
            backgroundColor: "#0073aa !important",
            color: "rgb(37, 37, 42)",
          },
        }),
      },
    },
  },

  focus: {
    default: {
      outlineWidth: "3px",
    },
  },

  fontFamily: {
    display: '"Inter", sans-serif', // applies to `h1`–`h4`
    body: '"Inter", sans-serif', // applies to `title-*` and `body-*`
  },
});
